const generateReferralLink = (utmSource, userId) =>
  `https://yola.com?utm_campaign=refer_a_friend&utm_source=${utmSource}&utm_medium=referer_${userId}`;

export default generateReferralLink;
